import { TApplicationFormatted } from './fetch-application.types';

export const mockedApplicationData: TApplicationFormatted = {
  status_change_date: '2021-09-24 11:42:24.480819+03:00',
  id: 'e35ad20e-c563-4b4f-80d7-5cde2b3993d7',
  created_at: '2021-09-24 11:42:24.480819+03:00',
  status: 'REGISTERED',
  updated_at: '2021-10-05T17:12:28.373765+03:00',
  application_types: [
    {
      name: 'Web',
      id: '3f17395b-1ee5-46ce-80a1-33e3ea5dbeb2',
    },
  ],
  products: [
    {
      name: 'Intergy',
      id: 'f8c9dece-375b-43a1-a8d5-d43b7657f97b',
    },
  ],
  name: 'Demo App 2',
  icon: '',
  company_name: 'Partner & Co.',
  categories: [
    {
      name: 'Value-Based Reimbursement Support',
      id: 'be08fb61-780e-4914-9f09-2c60e1d93319',
    },
  ],
  short_description: 'Application short description.',
  developer_name: 'First_name Last_name',
  secret: 'ghfjrdwdfgefsacgrtghseerfsqwer',
  clientId: 'ghfjrdwdfgefsacgrtghseerfsqwer',
  url: "https://stackoverflow.com/",
};
